import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {OsdKimeraService} from "@app/osd-annotation/services/osd-kimera.service";
import {
  addCalibrationData,
  addCalibrationDataFailure,
  addCalibrationDataSuccess
} from "@app/store/Actions/annotation-tool/calibration.actions";

@Injectable()
export class CalibrationEffects {

  loadCalibrationDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addCalibrationData),
      switchMap(({ gridId }) =>
        this.osdKimeraService.nmPerPixel$.pipe(
          map(calibrationData =>
            addCalibrationDataSuccess({ gridId, data: calibrationData })
          ),
          catchError(error =>
            of(addCalibrationDataFailure({ error }))
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly osdKimeraService: OsdKimeraService
  ) {}
}
